import styled from 'styled-components';
import { SlideModalSmoother } from '../../../abstract/modal/slide/SlideModalSmoother';

interface IButton {
  text?: string;
  handleClick: () => void;
}

interface SlideConfirmModalProps {
  isShow: boolean;
  height: number;
  description?: string;
  confirmButton?: IButton;
  closeButton: IButton;
  element?: JSX.Element;
  isShowCloseButton?: boolean;
  gap?: string;
  padding?: string;
}

export const SlideConfirmModal = ({
  isShow,
  height,
  description,
  confirmButton,
  closeButton,
  element,
  isShowCloseButton = false,
  gap,
  padding,
}: SlideConfirmModalProps) => {
  return (
    <SlideModalSmoother
      targetState={isShow}
      openDelayTime={0}
      height={`${height}px`}
      isShowCloseButton={isShowCloseButton}
      handleCloseButtonClick={closeButton.handleClick}
      padding={padding}
      gap={gap}
    >
      <Container>
        {description && <Description>{description}</Description>}

        {element && <BodyContaier>{element}</BodyContaier>}

        {(confirmButton || closeButton.text) && (
          <ButtonContainer>
            {confirmButton && (
              <BlueButton onClick={confirmButton.handleClick}>
                <BlueText>{confirmButton.text}</BlueText>
              </BlueButton>
            )}

            {closeButton.text && (
              <GreyButton onClick={closeButton.handleClick}>
                <GreyText>{closeButton.text}</GreyText>
              </GreyButton>
            )}
          </ButtonContainer>
        )}
      </Container>
    </SlideModalSmoother>
  );
};

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 24px;
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const BlueButton = styled.button`
  display: flex;
  max-height: 40px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-blue, #445eff);
`;

const BodyContaier = styled.div`
  width: 100%;

  gap: 24px;
`;

const ButtonContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const BlueText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

const GreyButton = styled.button`
  display: flex;
  max-height: 40px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const GreyText = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
